interface Config {
  hideFullTextBody: boolean;
}

// `AccordionEffects` defines the default behavior for `Accordion`
export const AccordionEffects = {
  collapse(index: string, config: Config) {
    const content = document.querySelector(`#content_${index} [data-behavior="details"]`);
    content?.classList.remove('[&>*]:h-fit');
    content?.classList.add('[&>*]:max-h-5');

    const addendum = document.querySelector(`#content_${index} [data-behavior="details_addendum"]`);
    addendum?.classList.add('hidden');

    const expandIcon = document.querySelector(`#toggle_icon_${index} .icon`);
    if (expandIcon) {
      expandIcon.innerHTML = '+';
    }

    if (config?.hideFullTextBody) {
      const contentText = document.querySelector(`#content_text_${index}`);
      contentText?.classList.add('hidden');
    }
  },
  expand(index: string, config: Config) {
    const content = document.querySelector(`#content_${index} [data-behavior="details"]`);
    content?.classList.remove('[&>*]:max-h-5');
    content?.classList.add('[&>*]:h-fit');

    const addendum = document.querySelector(`#content_${index} [data-behavior="details_addendum"]`);
    addendum?.classList.remove('hidden');

    const expandIcon = document.querySelector(`#toggle_icon_${index} .icon`);
    if (expandIcon) {
      expandIcon.innerHTML = '-';
    }

    if (config?.hideFullTextBody) {
      const contentText = document.querySelector(`#content_text_${index}`);
      contentText?.classList.remove('hidden');
    }
  }
};

// `Accordion` provides client-side UI state and behavior for
// `TenantWeb.Components.ProductPage.DetailsAccordion`.
//
// Delegates to `AccordionEffects` for expand/collapse implementation.
export const Accordion = {
  expanded: false,
  config() {
    return JSON.parse(this.el.dataset.config || '{}');
  },
  index() {
    return this.el.dataset.index;
  },
  mounted() {
    const expandButton = this.el.querySelector(`#accordion_toggle_${this.index()}`);
    expandButton.addEventListener('click', () => {
      if (!this.expanded) {
        window.AccordionEffects?.expand(this.index(), this.config());
      } else {
        window.AccordionEffects?.collapse(this.index(), this.config());
      }
      this.expanded = !this.expanded;
      // Analytics Tagging For MTA-5849 start.
      const productCardEvent = new CustomEvent('pdp.accordion', {
        detail: {
          productCardAction: this.expanded,
          productCardLabel: this.el.dataset.productLabel
        }
      });
      window.dispatchEvent(productCardEvent);
      // Analytics Tagging For MTA-5849 end.
    });

    if (this.index() == 0) {
      this.expanded = true;
    }
  }
};
